import {user_action} from "../actions/user";


const inited = {
    data: null
};

export default function userReducer(state = inited, action) {
    switch (action.type) {
        case user_action:
            return {
                ...state,
                ...(action.hasOwnProperty('payload') ? action.payload : inited)
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/libs/redux/reducres/user.js